const initialState = {
    isReadingCustomerPipelines: false,
    pipelines: [],
    count: 0,

    pipelineTimelines: {}
}

export default initialState;
